import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { Container } from '@plone/components';
import MobileNavigation from '@kitconcept/volto-light-theme/components/MobileNavigation/MobileNavigation';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';
import cx from 'classnames';

import Logo from '@plone/volto/components/theme/Logo/Logo';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

const messages = defineMessages({
  siteLabel: {
    id: 'siteLabel',
    defaultMessage: ' ',
  },
});

const InternetHeader = ({ pathname, token }) => {
  return (
    <div className="header">
            <div className="logo-nav-wrapper">
                <div className="logo">
                    <Logo />
                </div>

                <div className="nav-center">
                    <Navigation pathname={pathname} />
                </div>

                <div className="nav-right desktop-only">
                    {!token ? (
                      <UniversalLink href="/login" className="login-link">
                            Log in
                        </UniversalLink>
                    ) : (
                      <UniversalLink href="/logout" className="login-link">
                            Log out
                        </UniversalLink>
                    )}
                </div>


                <MobileNavigation pathname={pathname} />
            </div>
        </div>
  );
};

const IntranetHeader = ({ pathname, token }) => {
  return (
    <div className="header">
            <div className="logo-nav-wrapper">
                <div className="logo">
                    <Logo />
                </div>

                <div className="nav-center">
                    <Navigation pathname={pathname} />
                </div>

                <div className="nav-right">
                    {!token ? (
                      <UniversalLink href="/login" className="login-link">
                            Log in
                        </UniversalLink>
                    ) : (
                      <UniversalLink href="/logout" className="login-link">
                            Log out
                        </UniversalLink>
                    )}
                </div>

                <MobileNavigation pathname={pathname} />
            </div>
        </div>
  );
};

const Header = (props) => {
  const { pathname } = props;
  const intranetHeader = config.settings.intranetHeader;
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const content = useSelector((state) => state.content.data);
  const navRoot = useSelector((state) => state.navroot?.data?.navroot);
  const intl = useIntl();
  const translatedSiteLabel = intl.formatMessage(messages.siteLabel);

  return (
    <>
            <SlotRenderer name="aboveHeader" content={content} navRoot={navRoot} />
            <header
              className={cx('header-wrapper', { 'intranet-header': intranetHeader })}
            >
                <Container layout>
                    {intranetHeader ? (
                      <IntranetHeader pathname={pathname} token={token} />
                    ) : (
                      <InternetHeader pathname={pathname} token={token} />
                    )}
                </Container>
            </header>
            <SlotRenderer name="belowHeader" content={content} navRoot={navRoot} />
        </>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
};

Header.defaultProps = {
  token: null,
};

export default Header;
